import React, { useEffect, useState, useCallback } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "./Front/Header";
import Footer from "./Front/Footer";
import API_BASE_URL from "../Config";
import Pagination from "./Pagination";
import PriceRangePicker from "./PriceRangePicker";
import { v4 as uuidv4 } from "uuid";
import Select from "react-select";
//import "./FrontClinicList.css";
import "../styles/global.css";

/* ─────────────────────────────────────────────────────────────
   SUB-COMPONENTS (UI only — no logic)
───────────────────────────────────────────────────────────── */

/** Skeleton card shown while data loads */
const SkeletonCard = () => (
  <li className="cl-skeleton">
    <div className="sk-img" />
    <div className="sk-body">
      <div className="sk-line title" />
      <div className="sk-line short" />
      <div className="sk-line full" />
      <div className="sk-line medium" />
    </div>
  </li>
);

/** Star rating row */
const StarRating = ({ rating = 4.5 }) => {
  const full = Math.floor(rating);
  const half = rating % 1 >= 0.5 ? 1 : 0;
  const empty = 5 - full - half;
  return (
    <div className="cl-stars">
      <div className="cl-stars-icons">
        {[...Array(full)].map((_, i) => <i key={`f${i}`} className="fa-solid fa-star" />)}
        {half === 1 && <i className="fa-solid fa-star-half-stroke" />}
        {[...Array(empty)].map((_, i) => <i key={`e${i}`} className="fa-regular fa-star" />)}
      </div>
      <span className="cl-stars-count">{rating}</span>
    </div>
  );
};

const AccSection = ({ id, label, openSection, setOpenSection, children }) => {
  const isOpen = openSection === id;
  return (
    <div className="cl-acc-item">
      <button
        type="button"
        className={`cl-acc-btn${isOpen ? " is-open" : ""}`}
        onClick={() => setOpenSection(isOpen ? null : id)}
        aria-expanded="isOpen"
      >
        {label}
        <span className="cl-acc-icon">
          <i className="fa-solid fa-chevron-down" />
        </span>
      </button>
      <div className={`cl-acc-panel${isOpen ? " is-open" : ""}`}>
        {children}
      </div>
    </div>
  );
};

/* ─────────────────────────────────────────────────────────────
   FIX: FilterContent moved OUTSIDE the main component.
   Previously it was defined inside FrontClinicList, which caused
   React to treat it as a new component type on every render,
   unmounting/remounting the inputs and losing focus on each keystroke.
───────────────────────────────────────────────────────────── */
const FilterContent = ({
  accordionId,
  openSection,
  setOpenSection,
  /* department */
  filteredDepartments,
  searchDepartment,
  setSearchDepartment,
  selectedDep,
  handleDepChange,
  /* clinic */
  filteredClinic,
  searchClinic,
  setSearchClinic,
  selectedCli,
  handleCliChange,
  /* price */
  handleRangeChange,
  handleRangeAfter,
}) => (
  <>
    {/* Department */}
    <AccSection
      id={`${accordionId}-dept`}
      label="Department"
      openSection={openSection}
      setOpenSection={setOpenSection}
    >
      <div className="cl-filter-search px-0 mx-2">
        <input
          type="text"
          placeholder="Search department…"
          value={searchDepartment}
          onChange={(e) => setSearchDepartment(e.target.value)}
        />
      </div>
      <div className="cl-filter-list px-0">
        {filteredDepartments?.map((cat) => (
          <div
            key={cat.id}
            className="cl-filter-check form-check form-check-inline d-flex align-items-center gap-3 mx-2"
          >
            <input
              type="checkbox"
              value={cat.id}
              checked={selectedDep.includes(String(cat.id))}
              onChange={handleDepChange}
            />
            <label className="form-check-label" htmlFor={`cat_${cat.id}`}>
              {cat.name}
            </label>
          </div>
        ))}
      </div>
    </AccSection>

    {/* Clinic */}
    {/* <AccSection
      id={`${accordionId}-clinic`}
      label="Clinic"
      openSection={openSection}
      setOpenSection={setOpenSection}
    >
      <div className="cl-filter-search px-0 mx-2"> 
        <input
          type="text"
          placeholder="Search clinic…"
          value={searchClinic}
          onChange={(e) => setSearchClinic(e.target.value)}
        />
      </div> 
      <div className="cl-filter-list px-0">
        {filteredClinic?.map((cli) => (
          <div
            key={cli.id}
            className="cl-filter-check form-check form-check-inline d-flex align-items-center gap-3 mx-2"
          >
            <input
              type="checkbox"
              value={cli.id}
              checked={selectedCli.includes(String(cli.id))}
              onChange={handleCliChange}
            />
            <label className="form-check-label" htmlFor={`cli_${cli.id}`}>
              {cli.name}
            </label>
          </div>
        ))}
      </div>
    </AccSection> */}

  </>
);

/* ─────────────────────────────────────────────────────────────
   MAIN COMPONENT
───────────────────────────────────────────────────────────── */
const FrontClinicList = () => {

  const [clinics, setClinics] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [cliniccount, setClinicCount] = useState([]);
  const [sortBy, setSortBy] = useState("");

  const [department, setDepartment] = useState([]);
  const [searchDepartment, setSearchDepartment] = useState("");
  const [selectedDep, setSelectedDep] = useState([]);

  const filteredDepartments = department?.filter((cat) =>
    cat.name.toLowerCase().includes(searchDepartment.toLowerCase())
  );

  const sortOptions = [
    { label: "Alphabetically, A-Z", value: "az" },
    { label: "Alphabetically, Z-A", value: "za" },
  ];

  const tamilNaduCities = [
    "Chennai", "Coimbatore", "Madurai", "Trichy", "Salem", "Tirunelveli", "Erode",
    "Vellore", "Thoothukudi", "Dindigul", "Thanjavur", "Ranipet", "Sivakasi", "Karur",
    "Udhagamandalam", "Hosur", "Nagercoil", "Kanchipuram", "Kumarapalayam", "Karaikudi",
    "Neyveli", "Cuddalore", "Kumbakonam", "Tiruvannamalai", "Pollachi", "Rajapalayam",
    "Gudiyatham", "Pudukkottai", "Vaniyambadi", "Ambur", "Nagapattinam", "Viluppuram",
  ];
  const cityOptions = tamilNaduCities.map((city) => ({ value: city, label: city }));

  const fetchDepartmentData = () => {
    fetch(`${API_BASE_URL}api/departent_front`)
      .then((res) => res.json())
      .then((data) => {
        const list = Array.isArray(data) ? data : data.data;
        setDepartment(list || []);
      })
      .catch((err) => console.log(err));
  };

  const [clinic, setClinic] = useState([]);
  const [searchClinic, setSearchClinic] = useState("");
  const [selectedCli, setSelectedCli] = useState([]);

  const filteredClinic = clinic?.filter((cat) =>
    cat.name.toLowerCase().includes(searchClinic.toLowerCase())
  );

  const fetchClinicData = () => {
    fetch(`${API_BASE_URL}api/clinic_front`)
      .then((res) => res.json())
      .then((data) => {
        const list = Array.isArray(data) ? data : data.data;
        setClinic(list || []);
      })
      .catch((err) => console.log(err));
  };

  const [lastPage, setLastPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [minPrice, setMinPrice] = useState(0);
  const [maxPrice, setMaxPrice] = useState(10000);
  const [searchName, setSearchName] = useState("");
  const [city, setCity] = useState("");

  const [loading, setLoading] = useState(true);
  const [filterOpen, setFilterOpen] = useState(false);
  const [sortOpen, setSortOpen] = useState(false);
  const [openSection, setOpenSection] = useState("dept");

  /* FIX: fetchClinics now accepts clinicIds param */
  const fetchClinics = async (
    page = 1,
    min = 0,
    max = 10000,
    sortby = "",
    departmentsearch = [],
    name = "",
    cityVal = "",
    clinicIds = []
  ) => {
    setLoading(true);
    const departmentParm = departmentsearch.join(",");
    const clinicParm = clinicIds.join(",");
    const safeMin = parseFloat(min) || 0;
    const safeMax = parseFloat(max) || 10000;

    const response = await fetch(
      `${API_BASE_URL}api/clinicList` +
      `?minPrice=${safeMin}&maxPrice=${safeMax}` +
      `&deparments=${departmentParm}` +
      `&clinics=${clinicParm}` +
      `&sortby=${sortby}&page=${page}` +
      `&name=${encodeURIComponent(name)}&city=${encodeURIComponent(cityVal)}`
    );
    const json = await response.json();
    if (json.status) {
      setTotalPages(json.data.last_page);
      setClinicCount(json.data.total);
      setClinics(json.data.data);
      setCurrentPage(json.data.current_page);
      setLastPage(json.data.last_page);
    }
    setLoading(false);
  };

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      fetchClinics(1, 0, 10000, "", [], searchName);
    }, 500);
    return () => clearTimeout(delayDebounce);
  }, [searchName]);

  useEffect(() => {
    fetchClinics(1);
    fetchDepartmentData();
    fetchClinicData();
  }, []);

  let deviceId = localStorage.getItem("device_id");
  if (!deviceId) {
    deviceId = uuidv4();
    localStorage.setItem("device_id", deviceId);
  }

  const handleRangeChange = ([min, max]) => {
    console.log("live", min, max);
  };

  const handleRangeAfter = ([min, max]) => {
    setMinPrice(parseFloat(min));
    setMaxPrice(parseFloat(max));
    fetchClinics(1, parseFloat(min), parseFloat(max), sortBy, selectedDep, searchName, city, selectedCli);
  };

  /* Department checkbox handler */
  const handleDepChange = (e) => {
    const value = e.target.value;
    setSelectedDep((prev) => {
      const updated = e.target.checked
        ? [...prev, value]
        : prev.filter((id) => id !== value);
      fetchClinics(1, minPrice, maxPrice, sortBy, updated, searchName, city, selectedCli);
      return updated;
    });
  };

  /* FIX: Clinic checkbox handler (was missing entirely) */
  const handleCliChange = (e) => {
    const value = e.target.value;
    setSelectedCli((prev) => {
      const updated = e.target.checked
        ? [...prev, value]
        : prev.filter((id) => id !== value);
      fetchClinics(1, minPrice, maxPrice, sortBy, selectedDep, searchName, city, updated);
      return updated;
    });
  };

  const openFilter = () => setFilterOpen(true);
  const closeFilter = () => setFilterOpen(false);
  const openSort = () => setSortOpen(true);
  const closeSort = () => setSortOpen(false);

  const handleApplyFilter = () => closeFilter();

  /* FIX: reset also clears selectedCli and searchClinic */
  const handleResetFilter = () => {
    setSelectedDep([]);
    setSelectedCli([]);
    setMinPrice(0);
    setMaxPrice(10000);
    setSearchDepartment("");
    setSearchClinic("");
    fetchClinics(1, 0, 10000, sortBy, [], searchName, city, []);
  };
// ----pagination stsart -----//
  const handlePageChange = (page) => {
  fetchClinics(
    page,
    minPrice,
    maxPrice,
    sortBy,
    selectedDep,
    searchName,
    city,
    selectedCli
  );

  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
};

  /* Shared props passed down to both sidebar and drawer FilterContent instances */
  const filterContentProps = {
    openSection,
    setOpenSection,
    filteredDepartments,
    searchDepartment,
    setSearchDepartment,
    selectedDep,
    handleDepChange,
    filteredClinic,
    searchClinic,
    setSearchClinic,
    selectedCli,
    handleCliChange,
    handleRangeChange,
    handleRangeAfter,
  };

  return (
    <div className="cl-page">
      <Header />

      {/* Breadcrumb */}
      <section className="cl-breadcrumb-bar py-xl-3 py-3">
        <div className="container-fluid">
          <nav aria-label="breadcrumb">
           <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <Link to="/">
                  <i className="fa-solid fa-house me-1"></i> Home
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Clinic List
              </li>
            </ol>
          </nav>
        </div>
      </section>

      {/* Listing section */}
      <section className="cl-listing-section product-list section-padding pt-0 doctor-list mt-3">
        <div className="container-fluid px-lg-5">
          <div className="cl-layout product-listing-row">

            {/* ── Desktop sidebar ── */}
            <aside className="cl-sidebar filter-web left-filter-blade sidebar-filter-block px-0 pb-0">
              <div className="cl-filter-head sidebarfilter-menu-head py-0">
                <span className="cl-filter-head-title filter-heading">Filters</span>
                <button
                  type="button"
                  className="cl-filter-clear filter-clear my-2"
                  onClick={handleResetFilter}
                >
                  Clear All
                </button>
              </div>
              <FilterContent accordionId="sidebar" {...filterContentProps} />
            </aside>

            {/* ── Main content ── */}
            <div className="cl-main filter_options">

              {/* Search + city */}
              <div className="cl-search-bar doctor-filter-search">
                <div className="row g-2 align-items-center">
                  <div className="col-md-4 col-xl-3">
                    <Select
                      className="cl-city-select form-select-1"
                      options={cityOptions}
                      placeholder="📍 Select City"
                      onChange={(selected) => {
                        const val = selected?.value || "";
                        setCity(val);
                        fetchClinics(1, minPrice, maxPrice, sortBy, selectedDep, searchName, val, selectedCli);
                      }}
                      isClearable
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 1 }),
                        menu: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                    />
                  </div>
                  <div className="col-md-8 col-xl-9">
                    <div className="cl-search-wrap search-block">
                      <i className="fa-solid fa-search cl-search-icon search-icon" />
                      <input
                        type="text"
                        placeholder="Search clinic name…"
                        value={searchName}
                        id="searchInput"
                        autoComplete="off"
                        onChange={(e) => setSearchName(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Results header */}
              <div className="cl-results-header">
                <div>
                  <h4 className="cl-results-title">Clinic List</h4>
                  <p className="cl-results-count showing_items_count mb-0">
                    Showing <strong>{cliniccount}</strong> results
                  </p>
                </div>
                {/* Desktop sort */}
                <div className="d-lg-block d-none sort-dropdown dropdown">
                  <select
                    className="cl-sort-select form-select"
                    value={sortBy}
                    onChange={(e) => {
                      const value = e.target.value;
                      setSortBy(value);
                      fetchClinics(1, minPrice, maxPrice, value, selectedDep, searchName, city, selectedCli);
                    }}
                  >
                    <option value="">Sort By</option>
                    <option value="latest">Latest</option>
                    <option value="az">Alphabetically, A–Z</option>
                    <option value="za">Alphabetically, Z–A</option>
                    <option value="price_low_high">Price, low to high</option>
                    <option value="price_high_low">Price, high to low</option>
                  </select>
                </div>
              </div>

              {/* Cards */}
              {loading ? (
                <ul className="cl-grid doctor-card">
                  {[...Array(6)].map((_, i) => <SkeletonCard key={i} />)}
                </ul>
              ) : clinics.length > 0 ? (
                <ul className="cl-grid doctor-card">
                  {clinics.map((clinic) => (
                    <li className="cl-card category-block" key={clinic.id}>

                      {/* Image */}
                      <div className="cl-card-img flex-shrink-0">
                        <Link to={`/clinicdetails/${clinic.slug}`}>
                          <img
                            src={
                              clinic.image
                                ? `${API_BASE_URL}public/clinic/${clinic.image.split(",")[0]}`
                                : `${API_BASE_URL}public/noimage.jpg`
                            }
                            alt={clinic.name}
                          />
                        </Link>
                        <span className="cl-badge-verified">
                          <i className="fa-solid fa-circle-check" /> Verified
                        </span>
                      </div>

                      {/* Body */}
                      <div className="cl-card-body d-flex flex-column">
                        <Link to={`/clinicdetails/${clinic.slug}`} className="cl-card-name doctor-name">
                          {clinic?.name}
                        </Link>

                        <StarRating rating={4.5} />

                        {clinic?.department_name && (
                          <span className="cl-dept-pill">{clinic.department_name}</span>
                        )}

                        <div className="cl-card-addr doctor-designation doctor-location">
                          <i className="fa-solid fa-location-dot" />
                          <span>{clinic?.address}</span>
                        </div>
                      </div>

                      {/* Footer buttons */}
                      <div className="cl-card-footer category-card mt-0 mb-0">
                        <Link
                          to={`/clinicdetails/${clinic.slug}`}
                          className="dc-book-btn"
                          style={{ padding: '6px 14px', fontSize: '13px', minHeight: '36px', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                        >
                          <i className="fa-solid fa-calendar-check text-white" />
                          <span style={{ background: "none", height: "unset", width: "unset" }}> Book Visit</span>
                        </Link>
                        {/* <Link
                          to={`/clinicdetails/${clinic.slug}`}
                          className="cl-btn-secondary btn btn-main btn-css-1 book-btn rounded-pill"
                          style={{ padding: '6px 14px', fontSize: '13px', minHeight: '36px', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                        >
                          <i className="fa-solid fa-phone me-2" />
                          <span className="bg-transparent">Contact</span>
                        </Link> */}
                        <a
  href={`tel:${clinic?.mobile || ""}`}
  className="cl-btn-secondary btn btn-main btn-css-1 book-btn rounded-pill"
  style={{
    padding: "6px 14px",
    fontSize: "13px",
    minHeight: "36px",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap:"5px",
  }}
>
  <i className="fa-solid fa-phone" />
  <div className="bg-transparent"> Call Now</div>
</a>
                      </div>
                    </li>
                  ))}
                </ul>
              ) : (
                <div className="cl-empty">
                  <div className="cl-empty-icon">
                    <i className="fa-solid fa-hospital-user" />
                  </div>
                  <h5>No Clinics Found</h5>
                  <p>Try adjusting your filters or search terms to find clinics near you.</p>
                </div>
              )}

              {/* Pagination */}
              <div className="cl-pagination">
                {/* <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={fetchClinics}
                /> */}
                <Pagination
  currentPage={currentPage}
  totalPages={totalPages}
  onPageChange={handlePageChange}
/>
              </div>

            </div>
            {/* end cl-main */}
          </div>
        </div>
      </section>

      {/* ── Mobile bottom bar ── */}
      <div className="cl-mobile-bar mobile_filters mobile-filter">
        <button className="cl-mobile-bar-btn canvas-btn rounded-pill" onClick={openFilter}>
          <i className="fa-solid fa-filter text-dark" /> Filters
        </button>
        <button className="pl-mob-btn pl-mob-btn--filter rounded-pill" onClick={openSort}>
          <i className="fa-solid fa-up-down text-white" /> Sort By
        </button>
      </div>

      {/* Overlay */}
      <div
        className={`cl-overlay${filterOpen || sortOpen ? " is-visible" : ""}${filterOpen || sortOpen ? " is-open" : ""}`}
        onClick={() => { closeFilter(); closeSort(); }}
        aria-hidden="true"
      />

      {/* Filter drawer */}
      <div className={`cl-drawer${filterOpen ? " is-open" : ""}`} tabIndex="-1" aria-labelledby="clDrawerLabel">
        <div className="cl-drawer-header">
          <h5 className="cl-drawer-title" id="clDrawerLabel">Filters</h5>
          <button className="cl-drawer-close" type="button" onClick={closeFilter} aria-label="Close">
            <i className="fa-solid fa-xmark" />
          </button>
        </div>
        <div className="cl-drawer-body">
          <FilterContent accordionId="drawer" {...filterContentProps} />
        </div>
        <div className="cl-drawer-footer sidebarfilter_menu_footer">
          <button className="btn-reset btn btn_cancel" type="button" onClick={handleResetFilter}>Reset</button>
          <button className="btn-apply btn btn_apply" type="button" onClick={handleApplyFilter}>Apply Filters</button>
        </div>
      </div>

      {/* Sort bottom sheet */}
      <div className={`cl-sort-sheet${sortOpen ? " is-open" : ""}`} tabIndex="-1" aria-labelledby="clSortLabel">
        <div className="cl-sort-handle" />
        <div className="cl-sort-sheet-header">
          <h5 className="cl-sort-sheet-title" id="clSortLabel">Sort by</h5>
          <button className="cl-drawer-close" type="button" onClick={closeSort} aria-label="Close">
            <i className="fa-solid fa-xmark" />
          </button>
        </div>
        <div className="cl-sort-sheet-body">
          <div className="sort_by_list">
            {sortOptions.map((option) => (
              <div className="cl-sort-option form-check mb-3" key={option.value}>
                <input
                  className="sort-by form-check-input"
                  type="radio"
                  name="sortBy"
                  id={option.value}
                  value={option.value}
                  checked={sortBy === option.value}
                  onChange={(e) => {
                    const value = e.target.value;
                    setSortBy(value);
                    fetchClinics(1, minPrice, maxPrice, value, selectedDep, searchName, city, selectedCli);
                    closeSort();
                  }}
                />
                <label className="form-check-label" htmlFor={option.value}>
                  {option.label}
                </label>
              </div>
            ))}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default FrontClinicList;